export default __webpack_public_path__ + "static/media/usaFlag.1400f979.svg";